const auditLocationEnum = {
  "1": "On the Lot",
  "2": "Not On the Lot",
  "3": "At Auction",
}

export default auditLocationEnum
